import React, { useState } from "react"
import Input from "../../components/Input";
import Button from "../../components/Button";
import '../pages.css'
import logoProdesp from '../../images/Logo Prodesp novo horizontal_cor.png'
import logoExpansao from '../../images/logo-padrao.png'
import loading from '../../images/loading.png'
import validator from 'validator'
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const Changepassword = () => {
    const navigate = useNavigate()
    const { signup, changepswd } = useAuth();
    const [errorMessage, setErrorMessage] = useState('')
    const [invpass,setInvpass] = useState(true)
    const [notequal, setNotequal] = useState('')
    const [password, setPassword] = useState('')
    const [confirmpassword, setConfirmpassword] = useState('')
    const [cpf, setCpf] = useState('')
    const [code, setCode] = useState('')
    const [email, setEmail] = useState('')
    const [classe,setClasse] = useState('')
    const [classe2,setClasse2] = useState('')
    const [stt, setStt] = useState(false)
    const [errocadastro, setErrocadastro] = useState('')
    const [rotating,setRotating] = useState(false)
    const [disabled,setDisabled] = useState(false)

    const validate = (value) => { 
            if (validator.isStrongPassword(value, { 
                minLength: 8, minLowercase: 1, 
                minUppercase: 1, minNumbers: 1, minSymbols: 1 
            })) { 
                setErrorMessage('Senha OK')
                setClasse('strong_password')
                setInvpass(false)
            } else { 
                setErrorMessage('Sua senha é fraca') 
                setClasse('weak_password')
                setInvpass(true)
            } 
        }

    const same_paswd = (value) => {
        if(value != password){
            setNotequal('Senhas não são iguais')
            setClasse2('pswd_not_equal')
        }else{
            setNotequal('Senhas iguais')
            setClasse2('pswd_equal')
        }
    }

    const handleChange  = async() => {
        if(!cpf || !code || !email || !password || (notequal == 'Senhas não são iguais') || invpass){
            setErrocadastro('Dados incorretos')
        }else{
          setDisabled(true)
          setRotating(true)
          const res = await changepswd(cpf,email,code,password)
          if(!res.success) {setStt('com_erro')}
          else {setStt('sem_erro')}
          setDisabled(false)
          setRotating(false)
          setErrocadastro(res.message)

          if(res.success){
            setTimeout(() => {
              navigate('/')
            }, 4000);
          }
        }
    }

    return (
        <div className="container_login">
          <div className="logo_prodesp">
            <img src={logoProdesp} alt="logo Prodesp"/>
          </div>
          <div className="titulo_login">Mude sua senha</div>
          <div className="content">
            <Input
              type="text"
              placeholder="CPF"
              value={cpf}
              onChange={(e) => [setCpf(e.target.value)]}
            />
            <Input
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => [setEmail(e.target.value)]}
            />
            <Input
              type="text"
              placeholder="Código"
              value={code}
              onChange={(e) => [setCode(e.target.value)]}
            />
            <Input
              type="password"
              placeholder="Crie sua Senha"
              value={password}
              onChange={(e) => [setPassword(e.target.value), validate(e.target.value)]}
            />
            {errorMessage === '' ? null : 
                    <div className={classe} style={{ 
                        fontWeight: 'bold', 
                    }}>{errorMessage}</div>}
            <Input
              type="password"
              placeholder="Confirme sua Senha"
              value={confirmpassword}
              onChange={(e) => [setConfirmpassword(e.target.value), same_paswd(e.target.value)]}
            />
            {notequal === '' ? null : 
                    <div className={classe2} style={{ 
                        fontWeight: 'bold', 
                    }}>{notequal}</div>}
            <div className={stt}>{errocadastro}</div>
            {!rotating ? null : <div className="spinning"><img src={loading} alt="spinning"/></div>}
            <Button Text="Mudar senha" onClick={handleChange} Disabled={disabled}/>
          </div>
          <div className="div_logo_expansao">
            <img src={logoExpansao} alt="logo Prodesp"/>
          </div>
        </div>
    )
}

export default Changepassword